import React from 'react';

import { CustomToaster } from '../BaseUI';
import ProfileDetail from './ProfileDetail';

const Subscriber = () => {
  return (
    <>
      <ProfileDetail />
      <CustomToaster />
    </>
  );
};

export default Subscriber;
